export const sortChatsByLastMessage = (chats) => {
  return [...chats].sort((a, b) => {
    const dateA = a.lastMessageDate || a.createdAt || 0;
    const dateB = b.lastMessageDate || b.createdAt || 0;
    return dateB - dateA;
  });
};
